<div class="not-found">
    <mat-icon>priority_high</mat-icon>
    <h1>
        Page Not Found
    </h1>
</div>
